/**
 * file-downloader
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2017 Mediatel Limited.
 */

"use strict";

import IEDownloader from "./ie-downloader";
import SafariDownloader from "./safari-downloader";

export default function fileDownloader(fileContent, fileName, mimeType) {
    const fileExt = fileName.split('.').slice(-1).pop();
    if(!mimeType && (-1 !== ['csv', 'tsv'].lastIndexOf(fileExt))) {
        mimeType = 'application/vnd.ms-excel';
    }

    const IEdownloader = IEDownloader();
    const SFDownloader = SafariDownloader();

    if(IEdownloader.isIEDownloader()) {
        return IEdownloader.download(fileContent, mimeType, fileName);
    } else if (SFDownloader.isSafariDownloader()) {
        return SFDownloader.download(fileContent, mimeType, fileName);
    } else {
        const a = document.createElement('a');
        a.href = 'data:' + mimeType + ',' + encodeURIComponent(fileContent);
        a.target = '_blank';
        a.download = fileName;

        document.body.appendChild(a);
        a.click();
    }
};
